import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {LicensedAgent} from "../../../shared/interface/licensed-agent";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {LicensedAgentService} from "../../../shared/services/licensed-agent.service";
import {takeUntil} from "rxjs/operators";
import {
  AGENT_21_STATUS,
  AGENT_21_STATUS_ACTIVE,
  AGENT_21_STATUS_APPLICATION_FOR_RENEWAL,
  AGENT_21_STATUS_CANCELLATION_OF_RENEWAL,
  AGENT_21_STATUS_INVOICE_PAID,
  AGENT_21_STATUS_INVOICE_SENT, AGENT_21_STATUS_IT_EXPIRES,
  AGENT_21_STATUS_PARTNER_NOTIFICATION,
  AGENT_21_STATUS_REGISTRATION,
  AGENT_21_STATUS_RENEWAL_INVOICE_SENT,
  AGENT_21_STATUS_RESIGNATION,
  AGENT_21_STATUS_SEND_FOR_ACTIVATION,
  DictService,
  RECEIVABLES_IMPORT_ROW_STATUS,
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION
} from "../../../shared/services/dict.service";
import {
  ConfirmDialogWithReasonComponent
} from "../../../shared/components/confirm-dialog-with-reason/confirm-dialog-with-reason.component";
import {Dictionary} from "../../../shared/interface/dictionary";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-licensed-details-view',
  templateUrl: './licensed-details-view.component.html',
  styleUrls: ['./licensed-details-view.component.scss']
})
export class LicensedDetailsViewComponent implements OnInit, OnDestroy {
  @Input() licensed: Observable<LicensedAgent>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() licensedChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  userPermissions: ReplaySubject<UserPermissions>;
  licensedObject?: LicensedAgent;
  readonly AGENT_21_STATUS_RESIGNATION = AGENT_21_STATUS_RESIGNATION;
  readonly AGENT_21_STATUS_INVOICE_SENT = AGENT_21_STATUS_INVOICE_SENT;
  readonly AGENT_21_STATUS_REGISTRATION = AGENT_21_STATUS_REGISTRATION;
  readonly AGENT_21_STATUS_INVOICE_PAID = AGENT_21_STATUS_INVOICE_PAID;
  readonly AGENT_21_STATUS_SEND_FOR_ACTIVATION = AGENT_21_STATUS_SEND_FOR_ACTIVATION;
  readonly AGENT_21_STATUS_ACTIVE = AGENT_21_STATUS_ACTIVE;
  readonly AGENT_21_STATUS_PARTNER_NOTIFICATION = AGENT_21_STATUS_PARTNER_NOTIFICATION;
  readonly AGENT_21_STATUS_RENEWAL_INVOICE_SENT = AGENT_21_STATUS_RENEWAL_INVOICE_SENT;
  readonly AGENT_21_STATUS_APPLICATION_FOR_RENEWAL = AGENT_21_STATUS_APPLICATION_FOR_RENEWAL;
  readonly AGENT_21_STATUS_CANCELLATION_OF_RENEWAL = AGENT_21_STATUS_CANCELLATION_OF_RENEWAL;
  readonly AGENT_21_STATUS_IT_EXPIRES = AGENT_21_STATUS_IT_EXPIRES;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private licensedAgentService: LicensedAgentService,
    private snack: MatSnackBar,
    private router: Router,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }


  ngOnInit(): void {
    this.licensed
      .pipe(takeUntil(this.destroyed$))
      .subscribe((licensedAgent: LicensedAgent) => {
        this.licensedObject = licensedAgent;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  statusTo(statusKey: string): void {
    this.dictService.get(statusKey, AGENT_21_STATUS)
        .subscribe((dict: Dictionary) => {
          var textValue = '';
          if (dict.key === AGENT_21_STATUS_PARTNER_NOTIFICATION) {
            textValue = 'Zmieniając status na Powiadomienie Partnera nabywca licencji otrzyma e-mail z informacją o aktywacji licencji. Czy na pewno chcesz zmienić status?';
          } else {
             textValue = 'Czy na pewno chcesz zmienić status licencji na ' + dict.name + ' ?';

          }
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: {text: textValue},
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.licensedAgentService.statusUpdate(
                  this.licensedObject.uuid,
                  dict.id
              ).subscribe(() => {
                this.licensedChanged.emit();
                this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
              }, (error: HttpErrorResponse) => {
                this.snack.open('Przy zmieniono status wystąpił błąd', error.status.toString(), {duration: 2000});
                if (error.status === 400) {
                  this.snack.open(error.error.error.text, '400', {duration: 4000});
                }
              });
            }
          });
        });
  }

  day(time: any): string {
    if (!time) {
      return '';
    }

    const ms = 1000 * 60 * 60 * 24;

    const today = new Date().setHours(0, 0, 0, 0);
    const day = new Date(time).setHours(0, 0, 0, 0);

    const ilosc_dni = (day - today) / ms;
    return String(Math.trunc(ilosc_dni));
  }


}
